// startup
// Load entry module and return exports
__webpack_require__("./assets/scss/app.scss");
// This entry module is referenced by other modules so it can't be inlined
var __webpack_exports__ = __webpack_require__("./assets/js/app.js");
